import { useCallback, useEffect, useRef } from 'react';
import { debounce } from 'lodash-es';

import { usePanelPreferenceStore } from '@kc-console/context';

import { computePanelAvailability } from './computePanelAvailability';

/**
 * PanelInitializer
 *
 * - usePanelPreferenceStore 기반 패널 가용성 관리
 * - 로컬스토리지 초기화는 usePanelPreferenceStore의 persist 미들웨어가 처리
 * - 브라우저 리사이즈 시 패널 사용 가능 여부 업데이트
 */
const PanelInitializer = () => {
  const isMounted = useRef(false);
  const getPreference = usePanelPreferenceStore(state => state.getPreference);
  const updateAvailability = usePanelPreferenceStore(state => state.updateAvailability);

  const listPreference = getPreference('list');
  const detailPreference = getPreference('detail');

  const updateAvailablePanelState = useCallback(() => {
    const { innerWidth, innerHeight } = window;

    const isAvailableListPanel = computePanelAvailability({
      layoutType: 'list',
      position: listPreference.position,
      innerWidth,
      innerHeight,
    });

    const isAvailableDetailPanel = computePanelAvailability({
      layoutType: 'detail',
      position: detailPreference.position,
      innerWidth,
      innerHeight,
    });

    updateAvailability('list', isAvailableListPanel);
    updateAvailability('detail', isAvailableDetailPanel);
  }, [detailPreference.position, listPreference.position, updateAvailability]);

  useEffect(() => {
    const handleResize = debounce(updateAvailablePanelState, 100);

    updateAvailablePanelState();

    if (!isMounted.current) {
      isMounted.current = true;
      window.addEventListener('resize', handleResize);
    }

    return () => {
      isMounted.current = false;
      window.removeEventListener('resize', handleResize);
    };
  }, [updateAvailablePanelState]);

  return null;
};

export default PanelInitializer;
